import { render, staticRenderFns } from "./role-authority.vue?vue&type=template&id=c631621c&scoped=true"
import script from "./role-authority.vue?vue&type=script&lang=js"
export * from "./role-authority.vue?vue&type=script&lang=js"
import style0 from "./role-authority.vue?vue&type=style&index=0&id=c631621c&prod&lang=scss&scoped=true"
import style1 from "./role-authority.vue?vue&type=style&index=1&id=c631621c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c631621c",
  null
  
)

export default component.exports